import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ErrorService } from "../error/err.service";
import { RESTAPI } from "../shared/stateapimanagement/apiwithoutstate";
import { RESTPROMISE } from "../shared/stateapimanagement/promisewithoutstate";
import { API_STATEMANAGEMENT } from "../shared/stateapimanagement/api-statemanagement";
import { Observable, Subject } from "rxjs";
import { LongPollingStateLessAPIManagement } from "../shared/stateapimanagement/longpolling-withoutstate";
import { LongPollingPromiseAPIManagement } from "../shared/stateapimanagement/promiselongpolling-withstate";
import { mergeMap } from "rxjs/operators";
import { SharedService } from "../services/shared.service";
import { ToastService } from "../shared/custom-overlay/toast/toast.service";
import { LongPollingAPIManagement } from "../shared/stateapimanagement/longpolling-withstate";

@Injectable()

export class RuleService {

    componentdestroyed: Subject<number> = new Subject();
    customerChangeLogggedOff: Subject<boolean> = new Subject();

    constructor(
        public http: HttpClient,
        private sharedService: SharedService,
        private errorservice: ErrorService,
        private toastService: ToastService
    ) {
        this.sharedService.$userLoggedoff.pipe().subscribe((loggedoff)=>{
            this.customerChangeLogggedOff.next(loggedoff);
        })
    }

    checklogged() {
        return this.sharedService.$userLogged.getValue()
    }

    toStringify(postData: any) {
        return JSON.stringify(postData)
    }

    // Need to remove as per shared service
    headers = new HttpHeaders({ 'content-type': 'application/json','charset':'utf-8'});

    providerulestat = new RESTAPI(
        this.provideRuleStat, 
        this.http, 
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/stat/get',
        'Rule',
        this.toastService
    )
    provideRuleStat(requestdetails: any) {
        return this.http.post(environment.apiUrl + '/rule/stat/get', requestdetails, { headers: this.headers })
    }

    providerulelist = new API_STATEMANAGEMENT(
        this.provideRuleList, 
        this.http, 
        this.componentdestroyed.asObservable(), 
        this.customerChangeLogggedOff.asObservable()
    )
    provideRuleList(pagination: any) {
        return this.http.post(environment.apiUrl + '/rule/list/get', pagination, { headers: this.headers })
    }

    provideintellist = new API_STATEMANAGEMENT(
        this.provideIntelList, 
        this.http, 
        this.componentdestroyed.asObservable(), 
        this.customerChangeLogggedOff.asObservable()
    )
    provideIntelList(pagination: any) {
        return this.http.post(environment.apiUrl + '/intel_list/listView/get', pagination, { headers: this.headers })
    }

    provideintellistview = new API_STATEMANAGEMENT(
        this.provideIntelListView, 
        this.http, 
        this.componentdestroyed.asObservable(), 
        this.customerChangeLogggedOff.asObservable()
    )
    provideIntelListView(pagination: any) {
        return this.http.post(environment.apiUrl + '/intel_list/values/get', pagination, { headers: this.headers })
    }

    provideEventField(platform: any) {
        return this.http.post(environment.apiUrl + '/common/platformFields/get', JSON.stringify(platform), { headers: this.headers })
    }

    provideEdit(ruleId: any) {
        return this.http.post(environment.apiUrl + '/rule/edit/get', this.toStringify(ruleId), { headers: this.headers })
    }
    provideIntelEdit(listId: any) {
        return this.http.post(environment.apiUrl + '/intel_list/edit/get', this.toStringify({list_id:listId}), { headers: this.headers })
    }
    provideImportTable(list_id:any){
        return this.http.post(environment.apiUrl + '/intel_list/import/get', this.toStringify({list_id:list_id}), { headers: this.headers })
    }

    provideAlertEdit(ruleId: any) {
        return this.http.post(environment.apiUrl + '/alerts/rule/edit/get', this.toStringify(ruleId), { headers: this.headers })
    }

    postNewIntelList = new RESTPROMISE(
        this.postIntelListData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'intel_list/new/post',
        'IntelList',
        this.toastService
    )
    postIntelListData(postData: any) {
        return this.http.post(environment.apiUrl + '/intel_list/new/post', postData, { headers: this.headers });
    }

    postIntelListImport = new RESTPROMISE(
        this.postIntelListImportData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'intel_list/import/post',
        'IntelList',
        this.toastService
    )
    postIntelListImportData(postData: any) {
        return this.http.post(environment.apiUrl + '/intel_list/import/post', postData, { headers: this.headers });
    }

    postIntelListValues = new RESTPROMISE(
        this.postIntelListEditValues,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'intel_list/values/post',
        'IntelList',
        this.toastService
    )
    postIntelListEditValues(postData: any) {
        return this.http.post(environment.apiUrl + '/intel_list/values/post', postData, { headers: this.headers });
    }

    postIntelListDelete = new RESTPROMISE(
        this.postDeleteIntelList,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        '/intel_list/delete/post',
        'IntelList',
        this.toastService
    )
    postDeleteIntelList(postData: any) {
        return this.http.post(environment.apiUrl + '/intel_list/delete/post', postData, { headers: this.headers });
    }

    postEditIntelList = new RESTPROMISE(
        this.postEditIntelListData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'intel_list/edit/post',
        'IntelList',
        this.toastService
    )
    postEditIntelListData(postData: any) {
        return this.http.post(environment.apiUrl + '/intel_list/edit/post', postData, { headers: this.headers });
    }

    posteditrule = new RESTPROMISE(
        this.postEditRuleData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/edit/post',
        'Rule',
        this.toastService
    )
    postEditRuleData(postData: any) {
        return this.http.post(environment.apiUrl + '/rule/edit/post', postData, { headers: this.headers });
    }
    alertsummarycomponentDestroyed: Subject<number> = new Subject();
    
    ruletestrun= new LongPollingPromiseAPIManagement(
        this.ruleTestRunData,
        this.http,
        this.alertsummarycomponentDestroyed.asObservable(),
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        this.toastService,
        '/alerts/summary_onfilter/get',
        'Alerts'
    )

    ruleTestRun = new RESTPROMISE(
        this.ruleTestRunData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/testRun/get',
        'Rule',
        this.toastService
    )
    ruleTestRunLP = new LongPollingAPIManagement(
        this.ruleTestRunData,
        this.http,
        this.componentdestroyed,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/testRun/get',
        'Rule',
        this.toastService
    )
    ruleTestRunData(postData: any) {
        return this.http.post(environment.apiUrl + '/rule/testRun/get', postData, { headers: this.headers });
    }

    postnewrule = new RESTPROMISE(
        this.postRuleData,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/new/post',
        'Rule',
        this.toastService
    )

    postRuleData(ruleData: any) {
        return this.http.post(environment.apiUrl + '/rule/new/post', ruleData, { headers: this.headers });
    }

    checkIfRulenameExists(rulename: string) {
        return this.http.post(environment.apiUrl + '/rule/name/check', this.toStringify({ rulename: rulename }), { headers: this.headers })
    }
    checkIfIntelnameExists(rulename: string) {
        return this.http.post(environment.apiUrl + '/intel_list/name/check', this.toStringify({ intellist_name: rulename }), { headers: this.headers })
    }

    providelookbackAssets(ruleId: any) {
        return this.http.post(environment.apiUrl + '/rule/lookback/assetdata/get', ruleId, { headers: this.headers });
    }

    postlookback = new RESTAPI(
        this.postLookback,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/lookback/apply/post',
        'Rule',
        this.toastService
    )
    postLookback(lookbackdetails: any) {
        return this.http.post(environment.apiUrl + '/rule/lookback/apply/post', lookbackdetails, { headers: this.headers })
    }

    postlookbackdelete = new RESTAPI(
        this.postlookbackDelete,
        this.http,
        this.customerChangeLogggedOff.asObservable(),
        this.errorservice,
        'rule/lookback/delete/post',
        'Rule',
        this.toastService
    )
    postlookbackDelete(ruledetails) {
        return this.http.post(environment.apiUrl + '/rule/lookback/delete/post', ruledetails, { headers: this.headers })

    }

    providelookbackalerts = (() => {
        return new LongPollingStateLessAPIManagement(
            this.provideLookbackAlerts,
            this.http,
            this.customerChangeLogggedOff.asObservable(),
            this.errorservice,
            '/rule/lookback/alert/get',
            'Rule',
            this.toastService
        )
    })
    provideLookbackAlerts(requestdetails: any) {
        return this.http.post(environment.apiUrl + '/rule/lookback/alert/get', requestdetails, { headers: this.headers })
    }

    provideadditionallookbackalerts = (() => {
        return new LongPollingStateLessAPIManagement(
            this.provideAdditionalLookbackalerts,
            this.http,
            this.customerChangeLogggedOff.asObservable(),
            this.errorservice,
            '/rule/lookback/additionalevents/get',
            'Rule',
            this.toastService
        )
    })
    provideAdditionalLookbackalerts(additionaleventdetails: any) {
        return this.http.post(environment.apiUrl + '/rule/lookback/additionalevents/get', additionaleventdetails, { headers: this.headers })
    }
}